import { enUS, pl } from 'date-fns/locale';

type DatePickerLocale = typeof pl;

const LOCALES: Record<string, DatePickerLocale> = {
  en: enUS,
  'en-US': enUS,
  pl,
  'pl-PL': pl,
};

export function getDatePickerLocale(locale: string): DatePickerLocale {
  return LOCALES[locale] ?? pl;
}
